import type { ComponentProps } from 'react';
import { cn } from '@/lib/cn';

export function Kbd({ className, ...props }: ComponentProps<'kbd'>) {
  return (
    <kbd
      className={cn(
        'inline-flex h-4 min-w-4 items-center justify-center rounded-sm border border-border px-1',
        'font-sans text-2xs font-medium text-fg-subtle',
        className,
      )}
      {...props}
    />
  );
}

/** "⌘K" on Apple platforms, "Ctrl K" elsewhere. */
export function ModKey() {
  const isMac =
    typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
  return <Kbd>{isMac ? '⌘' : 'Ctrl'}</Kbd>;
}
